<template>
  <div>
    <div style="padding:6px 16px 0px 16px;">
      <div class="apply-title">
        <div>添加评论</div>
      </div>
      <el-form
          v-loading="loading"
          ref="formRef"
          :model="formValue"
          :rules="rules"
      >
        <el-form-item label="评论内容" prop="comments" required>
          <el-input
              type="textarea"
              v-model="formValue.comments"
              placeholder="请输入"
              maxlength="255"
              rows="4"
              show-word-limit
          />
        </el-form-item>
        <el-form-item>
          <image-upload @choiceImages="choiceImages" v-model="formValue.imageList" />
        </el-form-item>
        <!--      <el-form-item>-->
        <!--        <file-upload v-model="formValue.fileList" />-->
        <!--      </el-form-item>-->
      </el-form>
    </div>
    <div style="display: flex;justify-content: end">
      <el-button size="small" type="info" plain @click="$emit('close')">取 消</el-button>
      <el-button size="small" type="info" :loading="loading" @click="handleConfirm">评 论</el-button>
    </div>
  </div>
</template>

<script>
import { comments } from "@/api/oa/audit.js";
import ImageUpload from "./ImageUpload";

export default {
  name: "CommentModal",
  components: { ImageUpload },
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    processInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      formValue: {
        comments: "",
        imageList: [],
        fileList: [],
      },
      rules: {
        comments: [
          { required: true, message: "请填写评论内容", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(visible) {
        this.$emit("update:visible", visible);
      },
    },
  },
  methods: {
    choiceImages(val){
      this.formValue.imageList = val;
    },
    // 确认操作
    handleConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const { imageList, fileList, ...restParams } = this.formValue;
        console.log(this.processInfo);
        console.log(restParams)
        const params = {...this.processInfo, ...restParams, attachments: [...imageList, ...fileList],};
        this.loading = true;
        comments(params).then(() => {
            this.$message.success("评论成功");
            this.handleCancel();
            this.$emit('close')
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // 取消操作
    handleCancel() {
      this.$emit('cancel');
      this.$refs.formRef.resetFields();
      this.formValue = {
        comments: "",
        imageList: [],
        fileList: [],
      };
      this.show = false;
    },
  },
};
</script>
<style scoped>
.apply-title{
  font-weight: bold;
  font-size: 15px;
  text-align: center;
}
</style>